function normaliseRegistration(value) {
  return String(value || '')
    .replace(/[^A-Z0-9]/gi, '')
    .toUpperCase();
}

function cleanCsvValue(value) {
  return String(value || '')
    .replace(/^"|"$/g, '')
    .trim()
    .toUpperCase();
}

export function parseAircraftLookupCsv(csvText) {
  const lines = String(csvText || '')
    .split(/\r?\n/)
    .filter((line) => line.trim());

  if (lines.length <= 1) {
    return [];
  }

  return lines
    .slice(1)
    .map((line) => {
      const columns = line.split(',');

      const registration = cleanCsvValue(columns[0]);
      const icaoType = cleanCsvValue(columns[1]);
      const adsbHex = cleanCsvValue(columns[2]);

      return {
        registration,
        normalisedRegistration: normaliseRegistration(registration),
        icaoType,
        adsbHex,
      };
    })
    .filter(
      (aircraft) =>
        aircraft.normalisedRegistration &&
        aircraft.icaoType
    );
}

export function findAircraftByRegistration(aircraftList, registration) {
  const normalisedRegistration = normaliseRegistration(registration);

  if (!normalisedRegistration) {
    return null;
  }

  return (
    (aircraftList || []).find(
      (aircraft) =>
        aircraft.normalisedRegistration === normalisedRegistration
    ) || null
  );
}

export { normaliseRegistration };